'use strict'

const BigTitle =  {
    els: [],
    init: function(){
        BigTitle.els = document.querySelectorAll('.f-big-title');
        if(BigTitle.els.length){
            BigTitle.els.forEach(title => BigTitle.resizeTitle(title))

            window.addEventListener('resize', () => {
                BigTitle.els.forEach(title => BigTitle.resizeTitle(title))
            })
        }
    },
    resizeTitle: function (title) {
        let h2 = title.querySelector('h2')
        if(h2){
            let containerWidth = parseFloat(getComputedStyle(title).width); 
            let titleWidth = parseFloat(getComputedStyle(h2).width);
            let originalFontSize = parseFloat(getComputedStyle(h2).fontSize)
            let newFontSize = (originalFontSize * containerWidth) / titleWidth
            newFontSize -= 0.015 * newFontSize

            h2.style.fontSize = `${newFontSize}px`
        }
    }
}

export default BigTitle;